<template>
    <div>
        <div v-if="!rawHtml" class="flex-align-justify margin-top20 conhtml"><van-loading /></div>
        <div class="padding-left20 padding20X line-height25 padding-right15 font-size0 color-333 conhtml" v-html="rawHtml"></div>
    </div>
</template>
<style lang='scss'>
.conhtml{
    img{
        max-width:100%;
        display: block;
    }
}
</style>
<script>
    export default {
        components:{

        },
        data(){
           return {
               rawHtml:''
           }
        },
        methods:{
            getprivacyagreementbyid(){
                let id=this.$route.query.id||''
                this.$get({
                    url:this.$apis.getprivacyagreementbyid,
                    query:{
                        appid:this.$route.query.appid,
                        id:this.$route.query.id
                    }
                }).then(res =>{
                    this.rawHtml = res.data.userContent
                })
            }
        },
        mounted(){
            this.getprivacyagreementbyid()
        },
        created(){

        }
    }
</script>